import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["accountingNoteKind", "sellerHeader", "buyerHeader", "content1", "priceMirror", "lumpSumTax"]
  static outlets = ["invoice"]

  change(event) {
    const { issuerLabel, recipientLabel, content1Credit, content1Debit } = event.params
    const newVal = this.accountingNoteKindTarget.value
    const swapped = this.invoiceOutlet.incomeValue ? newVal === "debit" : newVal === "credit"

    this.sellerHeaderTarget.textContent = swapped ? recipientLabel : issuerLabel
    this.buyerHeaderTarget.textContent = swapped ? issuerLabel : recipientLabel
    this.content1Target.value = newVal === "credit" ? content1Credit : content1Debit
  }

  syncAmount(event) {
    this.priceMirrorTargets.forEach((field) => { field.value = event.target.value })
  }

  syncLumpSumTax(deptAttributes) {
    if (!this.hasLumpSumTaxTarget || !this.invoiceOutlet.incomeValue) return

    if (deptAttributes["lump_sum_taxed"] === true) {
      this.lumpSumTaxTarget.value = deptAttributes["default_lump_sum_tax"] || ""
    }
  }
}
